import type { User } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaPencilAlt } from 'react-icons/fa';
import { showModal } from '../../components/generic/Modal';
import { usePermission } from '../../hooks/usePermission';
import { UserEditModal } from './UserEditModal';

interface Props {
  user: User;
}

export const UserEditMenuItem = (props: Props) => {
  const { user } = props;
  const hasPermission = usePermission('update', 'user');

  const onClick = () => {
    showModal(UserEditModal, { user });
  };

  return (
    <ChakraV3.MenuItem value='edit' disabled={!hasPermission} onClick={onClick}>
      <FaPencilAlt />
      Edit
    </ChakraV3.MenuItem>
  );
};
